module.exports = __webpack_public_path__ + "static/RoslindaleText-Italic-e8c5463bd27d49452565fbd8ce24fafb.woff";